import { createFileRoute } from '@tanstack/react-router'
import { BrandingSettingsPage } from '@/features/settings/components/branding-settings-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/settings/branding',
)({
  component: BrandingSettingsPage,
})
